export default {
    transform(data) {
        if (data.locations) {
            return {
                ...data.locations[0],
                ...data,
                locations: data.locations.slice(1),
            }
        }
        return data
    },
}
